import CTA from "../CTA/CTA";
import styles from "./Hero.module.css";

export default function Hero({ hero }) {
  return (
    <div className={styles.heroBox}>
      <div className={styles.imgCol}>
        <div className={styles.blobWrapper}>
          <div className={styles.blobBg}></div>

          <div className={styles.blob}>
            <img src={hero.imgUrl} alt={hero.imgAlt} />

            <div className={styles.overlay}></div>
          </div>
        </div>
      </div>

      <div className={styles.textCol}>
        <h1>{hero.title}</h1>

        <p>{hero.text}</p>

        <CTA text={hero.cta} />

        <p className={styles.subCta}>{hero.subCta}</p>
      </div>
    </div>
  );
}
